<!--パーツ(2)：代表者連絡先情報ブロック-->
<form [formGroup]="formGroup">
  <div id="{{ id }}" class="p-booking-info-mdl__item">
    <!--(2-2)：開く-->
    <button
      id="{{ id }}-representative-information-open-button1"
      [attr.aria-controls]="id + '-representativeInformation-drawer-option1'"
      [attr.aria-expanded]="isOpen"
      (click)="clickShutter()"
      class="p-booking-info-mdl__open"
      [ngClass]="{ 'is-open': isOpen, 'u-cursor-default': isNotRegistered }"
    >
      <span class="p-booking-info-mdl__open-head">
        <span
          class="p-booking-info-mdl__open-title"
          [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
        ></span>
      </span>
      <!--(2-1)：登録状況-->
      <span
        *ngIf="this.parts.registrarionLabel !== ''"
        class="p-booking-info-mdl__open-state {{ registrarionClass }}"
        [innerHTML]="this.parts.registrarionLabel | staticMsg"
      >
      </span>
    </button>

    <div
      id="{{ id }}-representativeInformation-drawer-option1"
      class="p-booking-info-mdl__contents"
      [ngClass]="{ 'is-open': isOpen }"
    >
      <div class="p-booking-info-mdl__item-head p-booking-info-mdl__item-head--pb8">
        <span
          class="p-booking-info-mdl__item-head-title"
          style="display: flex; align-items: center; justify-content: space-between"
          ><span [innerHTML]="'label.representativeSelectionGroup' | staticMsg"></span>

          <!--(2-1)：登録状況(シャッターopen時)-->
          <span
            class="p-booking-info-mdl__open-state p-booking-info-mdl__open-state--editing u-after-image-none"
            style="font-weight: normal"
            *ngIf="isOpen && this.parts.registrarionLabel !== ''"
            [innerHTML]="this.parts.registrarionLabel | staticMsg"
          >
          </span>
        </span>
        <span class="p-booking-info-mdl__item-head-text">
          <p
            class="p-booking-info-mdl__text"
            [innerHTML]="'label.representativeSelectionGroup.complement' | staticMsg"
          ></p>
        </span>
      </div>

      <!--(2-3)：代表者連絡先情報詳細-->
      <div class="p-booking-info-mdl__section">
        <div class="p-booking-info-mdl__block">
          <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
            <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.eMail.passengerInput' | staticMsg"></h3>
            <span class="c-text-with-tooltip__tooltip">
              <!--ヘルプアイコン ※代表者メールアドレス -->
              <asw-tooltip
                iconImage='<img src="assets/images/icon_help_primary_20.svg" width="20" height="20" alt="help" />'
                [tooltipContent]="'tooltip.upgradeNotificationEmail' | staticMsg"
                displayAreaClass="p-booking-info-mdl"
              ></asw-tooltip>
            </span>
            <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
          </div>
          <!--(2-4)：代表者メールアドレス-->
          <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
            <div class="p-booking-info-mdl__row-item">
              <span class="u-visually-hidden" [innerHTML]="'reader.eMailAddress' | staticMsg"> </span>
              <asw-input
                id="{{ id }}-address"
                name="{{ id }}-address"
                [label]="'label.eMailAddress.passengerInput' | staticMsg"
                [placeholder]="'placeholder.eMailAddress' | staticMsg"
                formControlName="representativeEmailFc"
                maxlength="50"
                [conversionType]="'email'"
              >
              </asw-input>
            </div>
          </div>
          <!--(2-5)：代表者メールアドレス(確認用)-->
          <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
            <div class="p-booking-info-mdl__row-item">
              <div class="c-form-element-input">
                <span class="u-visually-hidden" [innerHTML]="'reader.confirmMailAddress' | staticMsg"> </span>
                <asw-input
                  id="{{ id }}-address-confirm"
                  name="{{ id }}-address-confirm"
                  label="{{ 'label.confirmMailAddress' | staticMsg }}"
                  placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
                  formControlName="representativeConfirmEmailFc"
                  maxlength="50"
                  [conversionType]="'email'"
                  disablePaste
                ></asw-input>
              </div>
            </div>
          </div>
        </div>

        <div class="p-booking-info-mdl__block">
          <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
            <h3
              class="p-booking-info-mdl__heading-title"
              [innerHTML]="'label.telNumber.passengerInput' | staticMsg"
            ></h3>
            <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
          </div>
          <!--(2-6)：代表者電話番号種別-->
          <div class="p-booking-info-mdl__row p-booking-info-mdl__row--mb16">
            <div class="p-booking-info-mdl__row-item">
              <asw-radiobutton-box
                #radiobuttonBox
                id="{{ id }}-p-booking-info-mdl__row_boxradio"
                name="{{ id }}-p-booking-info-mdl__row_boxradio"
                legend="{{ 'label.telNumber.passengerInput' | staticMsg }}"
                [text]="boxRadioLabel"
                (changeEvent)="changeTellType($event)"
                [errorMessage]="radioBoxErrorInfo"
                [(selectedItem)]="selectedTellType"
              >
              </asw-radiobutton-box>
            </div>
          </div>
          <!--(2-7)：代表者電話番号国、(2-8)：代表者電話番号の国番号、(2-10)：代表者電話番号-->
          <div class="p-input-block01__row-body-item">
            <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
              <asw-select
                id="{{ id }}-phone-country"
                name="{{ id }}-phone-country"
                label="{{ 'label.countryCode' | staticMsg }}"
                formControlName="phoneCountryCodeFc"
              >
                <option value="" [innerHTML]="'placeholder.pleaseSelect' | staticMsg"></option>
                <option
                  *ngFor="let phoneCountryInfo of parts.phoneCountry"
                  [value]="phoneCountryInfo.countryCode"
                  [innerHTML]="phoneCountryInfo.countryName"
                ></option>
              </asw-select>
            </div>
          </div>
          <div class="p-input-block01__row-body-item">
            <div class="p-input-block01__row-body-item-head">
              <p
                id="describe01"
                class="p-input-block01__row-body-item-text"
                [innerHTML]="'label.phoneNumberAttention' | staticMsg"
              ></p>
            </div>
            <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
              <span class="u-visually-hidden" [innerHTML]="'reader.telephoneNumber.passengerInput' | staticMsg"></span>
              <asw-input
                id="{{ id }}-phone-number"
                name="{{ id }}-phone-number"
                label="{{ 'label.telephoneNumber.passengerInput' | staticMsg }}"
                formControlName="phoneNumberFc"
                placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
                displayType="phone"
                phoneCode="{{ countryPhoneExtension !== '' ? '+' + countryPhoneExtension : '' }}"
                maxlength="16"
                [conversionType]="'phoneNumber'"
              >
              </asw-input>
            </div>
          </div>
        </div>
        <!--(2-10)：閉じる-->
        <div *ngIf="parts.isCloseEnable" class="p-booking-info-mdl__section">
          <div class="p-booking-info-mdl__block">
            <div class="p-booking-info-mdl__close">
              <button
                id="{{ id }}-representative-information-close-button"
                class="p-booking-info-mdl__close-btn"
                [attr.aria-controls]="id + '-representativeInformation-drawer-option1'"
                [attr.aria-expanded]="isOpen"
                (click)="clickShutterClose()"
              >
                <span class="p-booking-info-mdl__close-text" [innerHTML]="'label.fold' | staticMsg"></span>
              </button>
            </div>
          </div>
        </div>

        <!--(15-7)：入力完了操作エリア-->
        <asw-passenger-information-request-input-complete-operation-area
          *ngIf="parts.isEnableComplete"
          id="{{ id }}-passenger-information-representativeInformation"
          [parts]="inputCompleteOperationData"
          (nextEvent)="clickNextButton()"
          (saveEvent)="clickSaveButton()"
        ></asw-passenger-information-request-input-complete-operation-area>
      </div>
    </div>
  </div>
</form>
